module.exports = __webpack_public_path__ + "static/media/star-with-bg.1e35f0d8.svg";